"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _mapping = require("../mapping");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// TODO improve component
var AemLayoutItem = function AemLayoutItem(_ref) {
  var type = _ref[':type'],
      containerCount = _ref.containerCount,
      rest = _objectWithoutProperties(_ref, [":type", "containerCount"]);

  if (!_mapping.AemMapComponent.hasOwnProperty(type)) {
    return null;
  } // @ts-ignore


  var Component = _mapping.AemMapComponent[type].component;

  if (rest.hasOwnProperty(':items') && rest.hasOwnProperty(':itemsOrder')) {
    var items = rest[':items'],
        itemsOrder = rest[':itemsOrder'],
        styleProps = _objectWithoutProperties(rest, [":items", ":itemsOrder"]);

    return /*#__PURE__*/_react.default.createElement(Component, styleProps, itemsOrder.map(function (key, index) {
      return /*#__PURE__*/_react.default.createElement(AemLayoutItem, _extends({
        key: "".concat(containerCount, "_").concat(index)
      }, items[key]));
    }));
  } else {
    return /*#__PURE__*/_react.default.createElement(Component, rest);
  }
};

var _default = AemLayoutItem;
exports.default = _default;